import type { FC, ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { CloseIcon } from "../../Icons/CloseIcon";
import type { ModalSize } from "../../../store/layout";
import styles from "./Modal.module.css";

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  title?: string;
  size?: ModalSize;
}

export const Modal: FC<ModalProps> = ({
  open,
  onOpenChange,
  children,
  title,
  size = "medium",
}) => {
  const sizeClass = {
    small: styles.contentSmall,
    medium: styles.contentMedium,
    large: styles.contentLarge,
    auto: styles.contentAuto,
  }[size];

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={`cl-configurator ${styles.overlay}`} />
        <Dialog.Content
          className={`cl-configurator ${styles.content} ${sizeClass}`}
          aria-describedby=""
        >
          <VisuallyHidden.Root>
            <Dialog.Title>{title || "Dialog"}</Dialog.Title>
          </VisuallyHidden.Root>

          <Dialog.Close className={styles.closeButton} aria-label="Close">
            <CloseIcon size={20} color="text" />
          </Dialog.Close>

          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
